import React from 'react';
import PropTypes from 'prop-types';
import VideoTile from 'components/VideoTile';
import { renderImage, NFT_THUMBNAIL_LEFT } from 'helpers/ImageHelper';
import Style from './NFTThumbnail.module.scss';

const NFTThumbnail = ({ image = '', video = '' }) =>
  video ? (
    <div className={Style.container}>
      <div className={Style.thumbnailContainer}>
        <VideoTile
          data-test="nft-left-video"
          id={`nft-left-video-${video}`}
          image={image}
          load
          loop
          play
          renderImage={opts => renderImage({ ...opts, imageType: NFT_THUMBNAIL_LEFT })}
          timer={0}
          video={video}
          videoPosterStyle={Style.thumbnail}
          videoStyle={Style.videoThumbnail}
        />
      </div>
    </div>
  ) : (
    <div className={Style.imageContainer}>
      <div className={Style.image}>
        {renderImage({
          className: Style.nftImage,
          src: image,
          imageType: NFT_THUMBNAIL_LEFT,
        })}
      </div>
    </div>
  );

NFTThumbnail.propTypes = {
  image: PropTypes.string,
  video: PropTypes.string,
};

export default NFTThumbnail;
